module.exports = __webpack_public_path__ + "img/3-4.59a725b5.png";